import { render } from "./uploadForm.vue?vue&type=template&id=3a05fa83"
import script from "./uploadForm.vue?vue&type=script&lang=js"
export * from "./uploadForm.vue?vue&type=script&lang=js"

import "./uploadForm.vue?vue&type=style&index=0&id=3a05fa83&lang=css"
script.render = render

export default script